<template>
  <div class="mt-4 px-1">
    <div class="space-y-4">

      <div class="flex gap-x-2 bg-gray-100 rounded-[10px] p-3 mb-4">
        <i class="far fa-info-circle text-xs"></i>
        <p class=" text-sm cstu-text-gray-400">
          Tell us what your brand stands for? its mission, personality, or voice. AI uses this to better understand and represent your brand.</p>
      </div>
      <!-- Brand Info Section -->
      <div>
        <label class="block mb-2 font-medium text-[#3C4549]">
          Brand Info
        </label>
        <Textarea
          :model-value="setupInfo.text.content"
          placeholder="Tell us about your brand, what you do, your tone, and who you serve."
          rows="4"
          full-width
          radius="lg"
          size="lg"
          :max-length="maxCharacters"
          @update:model-value="setupInfo.text.content = $event"
        />
        <div class="flex justify-end mt-2">
          <span class="text-sm text-gray-700">
            {{ setupInfo.text.content.length }}/{{ maxCharacters }} characters
          </span>
        </div>
      </div>

      <!-- Text Examples Section -->
      <div>
        <label class="block mb-3 font-medium text-gray-900">
          Try some text examples below
          <i
            v-tooltip="'Click to use these examples as a starting point'"
            class="far fa-question-circle p-0 cursor-pointer text-primary-cs ml-2"
          ></i>
        </label>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-3 mt-3">
          <div
            v-for="(example, index) in textExamples"
            :key="index"
            v-tooltip="copiedExampleIndex === index ? 'Copied!' : 'Click to copy example'"
            :class="[
              'relative p-4 border-gray-500 cursor-pointer transition-all duration-200 group text-example-container',
              { 'border-r': index !== textExamples.length - 1 },
            ]"
            @click="selectExample(example, index)"
          >
            <i
              v-if="copiedExampleIndex !== index"
              v-tooltip="'Copy example'"
              class="far fa-copy absolute top-4 right-4 text-gray-400 group-hover:text-primary-cs"
            ></i>
            <i
              v-else
              v-tooltip="'Copied!'"
              class="fas fa-check absolute top-4 right-4 text-green-500"
            ></i>
            <p class="text-sm text-gray-800 pr-2 text-example">{{ example }}</p>
            <div class="text-fade-overlay"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useSetup } from '@modules/publisher/ai-content-library/composables/useSetup'
import {Textarea} from '@contentstudio/ui'
const { setupInfo } = useSetup()
const maxCharacters = 1000
const copiedExampleIndex = ref(null)

const textExamples = [
  'We help small businesses grow their online presence through powerful yet easy-to-use social media management tools. Our mission is to simplify digital marketing, making it accessible, affordable, and effective for everyone.',
  'At FutureFlow, we build intelligent automation systems for fast-scaling startups and enterprise teams. Our solutions are smart, efficient, and built to help tech-driven companies operate at peak performance.',
  'Serenity Co. offers high-quality wellness products crafted to bring balance and calm into your life. We believe in intentional living, natural ingredients, and thoughtful self-care experiences for modern lifestyles.',
]

const selectExample = (example, index) => {
  navigator.clipboard.writeText(example).then(() => {
    copiedExampleIndex.value = index
    setTimeout(() => {
      copiedExampleIndex.value = null
    }, 2000)
  }).catch(err => {
    console.error('Failed to copy text: ', err)
    // Optionally, provide user feedback on copy failure
  })
}
</script>

<style scoped>
.line-clamp-3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.text-example-container {
  position: relative;
  overflow: hidden;
  max-height: 120px;
}

.text-example {
  max-height: 100px;
  overflow: hidden;
}

.text-fade-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 60px;
  background: linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%);
  pointer-events: none;
}
</style>
